// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sj","title":"sk","notSelected":"sl","duration":"sm","image":"sn","infoWrapper":"so","description":"sp"};